import app from "@/main";
import { RESET_IFRAME_CART_INIT } from "@/utils/event.constants";
import { createDefaultApiCache } from "@/utils/sessionDataCache";

export default {
  setOldTokens(state, { access, refresh, status }) {
    state.tokens.access = access;
    state.tokens.refresh = refresh;
    if (status) state.status = status;
  },
  setNewTokens(state, { access, refresh, status }) {
    state.tokens.access = access;
    state.tokens.refresh = refresh;
    if (status) state.status = status;
    app.config.globalProperties.$DbStorage.setItem("rocketfuel_access", access);
    app.config.globalProperties.$DbStorage.setItem(
      "rocketfuel_refresh",
      refresh
    );
    if (status)
      app.config.globalProperties.$DbStorage.setItem(
        "rocketfuel_status",
        status
      );
  },
  setPlaidLinkTokens(state, token) {
    state.plaidToken = token;
  },
  setStatus(state, status) {
    app.config.globalProperties.$DbStorage.setItem("rocketfuel_status", status);
    state.status = status;
  },
  logOut() {
    try {
      app.config.globalProperties.$DbStorage.removeItem("rocketfuel_access");
      app.config.globalProperties.$DbStorage.removeItem("rocketfuel_refresh");
      app.config.globalProperties.$DbStorage.removeItem("rocketfuel_status");
      app.config.globalProperties.$DbStorage.removeItem("isGuestUser");
    } catch (e) {
      // no log
    }
    this.state.auth.tokens.access = "";
    this.state.auth.tokens.refresh = "";
    this.state.auth.status = 0;
    this.state.isGuestUser = false;
    this.state.user.stockExchanges = {};
    this.state.user.selectedExchange = {};
    this.state.user.stocks = {};
    this.state.user.userInfo = {};
    // this.state.user.cart = {};
    this.state.user.txs = {};
    this.state.user.stores = {};
    this.state.user.extensionHeight = "100px";
    this.state.user.settings = {};
    this.state.user.currencies = [];
    this.state.user.displayCurrency = {};
    this.state.user.apiCache = createDefaultApiCache();
    this.state.user.enrolledInRewards = {};
    this.state.user.rewardsOptInPending = false;
    this.state.ssoUser = false;
    // this.state.user.marketInfo = {};
    window.EventBus?.emit(RESET_IFRAME_CART_INIT);
  },
  setRestoreData(state, data) {
    state.restoredData = data;
  },
  setUserId(state, data) {
    state.userId = data;
  },
  setGuestStatus(state, data) {
    state.isGuestUser = data;
    app.config.globalProperties.$DbStorage.setItem("isGuestUser", data);
  },
  setUserEmail(state, data) {
    state.userEmail = data;
  },
  setTemporaryTokens(state, { access, refresh }) {
    state.tokens.tempAccess = access;
    state.tokens.tempRefresh = refresh;
  },
  changePaymentCompleted(state) {
    state.paymentCompleted = 1;
  },
  ssoUser(state, data) {
    state.ssoUser = data;
  },
  setOrderData(state, data) {
    state.orderData = data;
  },
};
